/**
 * Generated from the "artisan make:alpine" command
 */

export type NotificationBannerType = 'success' | 'info' | 'danger';
const NOTIFICATION_ALERT_TYPES: Array<NotificationBannerType> = ["success", "info", "danger"];

export function isValidNotificationBannerType(value: string): value is NotificationBannerType {
    return NOTIFICATION_ALERT_TYPES.includes(value as NotificationBannerType);
}

// Your alpine data and methods
export interface AlpineData {
    message: string,
    type: string,
    onClose: (() => void) | null,

    setMessage(message: string, type: NotificationBannerType, onClose?: AlpineData["onClose"]): void
    closeBanner(): void
}
